import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { ElementProps } from '@/components/sections/builder/types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { IBlogPost } from '@/types/blog';
import clsx from 'clsx';
import { ImageIcon } from 'lucide-react';
import { shallow } from 'zustand/vanilla/shallow';

const defaultData: BlogDetailTitleElementDataType = {
  name: 'Feature Image',
  label:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at pretium odio. Maecenas viverra tortor consequat, pulvinar felis nec, aliquam diam. Nulla rutrum diam eros, ac dignissim quam pulvinar quis. Aliquam libero metus, posuere vitae maximus ac, suscipit eget mauris. Donec mauris augue, mollis in aliquet sit amet, bibendum vitae sapien.',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as BlogDetailTitleElementDataType;
  const parentData = (element.parentData || {}) as IBlogPost;

  return (
    <>
      <div className=''>
        <div
          className={clsx(
            'image_padding',
            data.imageRatio === 'adaptToImage' && 'img_ratio_adapt',
            data.imageRatio === 'small' && 'img_ratio_small',
            data.imageRatio === 'medium' && 'img_ratio_medium',
            data.imageRatio === 'large' && 'img_ratio_large'
          )}
        >
          {parentData.image_banner && (
            <div className=''>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                className={cn('img w-full', data.imageRatio)}
                src={parentData.image_banner as string}
                alt='add'
              />
            </div>
          )}
        </div>
        <style jsx>
          {`
            .img_ratio_adapt img {
              object-fit: contain !important;
            }
            .img_ratio_small img {
              object-fit: cover !important;
              aspect-ratio: 16 / 4 !important;
              --ratio-percent: 100% !important;
            }
            .img_ratio_medium img {
              object-fit: cover !important;
              aspect-ratio: 16 / 9 !important;
              --ratio-percent: 100% !important;
            }
            .img_ratio_large img {
              object-fit: cover !important;
              aspect-ratio: 1/1 !important;
              --ratio-percent: 100% !important;
            }
          `}
        </style>
      </div>
    </>
  );
};

export const ElementPreviewIcon = ImageIcon;

export const POSITION = [
  { label: 'Adapt to image', value: 'adaptToImage' },
  { label: 'Small', value: 'small' },
  { label: 'Medium', value: 'medium' },
  { label: 'Large', value: 'large' },
];

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as BlogDetailTitleElementDataType;

  return (
    <div>
      <div className='mb-4 mt-2 font-bold'>Featured image height</div>

      <Select
        name='Image Ratio'
        value={data.imageRatio}
        onValueChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            imageRatio: v,
          })
        }
      >
        <SelectTrigger className='py-5'>
          <SelectValue placeholder='Select' />
        </SelectTrigger>
        <SelectContent>
          {POSITION.map((obj) => (
            <SelectItem key={obj.value} value={obj.value}>
              {obj.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

const BlogFeaturedImage = {
  type: 'featured_image',
  group: 'blog_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default BlogFeaturedImage;
